import * as React from 'react';

export const ArrowRightCircleLine = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    ref={ref}
    {...props}
  >
    <path
      d='M23.064 12C23.064 18.1072 18.1074 23.0638 12.0001 23.0638C5.8929 23.0638 0.936305 18.1072 0.936306 12C0.936306 5.89275 5.8929 0.936156 12.0001 0.936157C18.1074 0.936157 23.064 5.89275 23.064 12ZM3.14907 12C3.14907 16.8902 7.10992 20.8511 12.0001 20.8511C16.8903 20.8511 20.8512 16.8902 20.8512 12C20.8512 7.10977 16.8903 3.14892 12.0001 3.14892C7.10992 3.14892 3.14907 7.10977 3.14907 12ZM12.0001 13.1064L7.5746 13.1064L7.5746 10.8936L12.0001 10.8936L12.0001 7.57445L16.4257 12L12.0001 16.4255L12.0001 13.1064Z'
      fill='currentColor'
    />
  </svg>
);
